import script from "./HijriDatePickr.vue?vue&type=script&setup=true&lang=js"
export * from "./HijriDatePickr.vue?vue&type=script&setup=true&lang=js"

import "./HijriDatePickr.vue?vue&type=style&index=0&id=41bd9bfd&lang=scss"

const __exports__ = script;

export default __exports__